/* hs-eslint ignored failing-rules */

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { fetchBannerInfo } from '../api/accountVerification';
import useBanner from '../hooks/useBanner';
import useUserHidden from '../hooks/useUserHidden';
import { sourceAppValues } from '../types';
import Banner from './Banner';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const AccountVerificationBanner = ({
  scope,
  source
}) => {
  const [bannerInfo, setBannerInfo] = useState(undefined);
  const [fetchFinished, setFinishedFetching] = useState(false);
  const [bannerHiddenByUserFor, setBannerHiddenByUserFor] = useUserHidden();
  const {
    showBanner,
    showCta,
    alertType,
    langPath,
    redirectUrl,
    closable
  } = useBanner(bannerHiddenByUserFor(scope), bannerInfo);
  useEffect(() => {
    if (scope) {
      const sourceURL = window.location.href;
      fetchBannerInfo(scope, sourceURL).then(setBannerInfo).catch(console.error).finally(() => setFinishedFetching(true));
    }
  }, [scope, source]);
  useEffect(() => {
    if (fetchFinished && !closable) {
      setBannerHiddenByUserFor(scope)(false);
    }
  }, [fetchFinished, closable]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!showBanner) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(Banner, {
    redirectUrl: redirectUrl,
    alertType: alertType,
    showCta: showCta,
    langPath: langPath,
    closable: closable,
    onClose: () => setBannerHiddenByUserFor(scope)(true)
  });
};
AccountVerificationBanner.propTypes = {
  scope: PropTypes.string.isRequired,
  source: PropTypes.oneOf(sourceAppValues).isRequired
};
export default AccountVerificationBanner;